import * as React from 'react';
import { Card, LineItemBundleRow } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const CardGlassesConfiguration = ({ bundleChildLineItems  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React.createElement(Card.Section, null, bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.map((item, i)=>/*#__PURE__*/ React.createElement(LineItemBundleRow, {
            key: `${item.body}-${i}`,
            title: item.title,
            body: item.body,
            currency: intl.currency,
            price: item.price,
            originalPrice: item.originalPrice,
            priceIsZeroLabel: intl.getLabel('cart.lineItem.glasses.isIncluded', {
                hideLabelKey: true
            }),
            action: item.action
        })
    ));
};

export { CardGlassesConfiguration };
//# sourceMappingURL=CardGlassesConfiguration.js.map
